exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav {\n\tposition: absolute;\n    z-index: 3;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 100%;\n    pointer-events: none;\n\tmargin-left: 0px;\n\tpadding: 0 10px;\n\theight: 45px;\n    background-color: #333;\n\n}\n\na, select {\n\tbackground-color: #333;\n\tpadding: 8px;\n\tmargin: 2px;\n\tborder-radius: 2px;\n\t/* border: 1px solid #fff; */\n\tpointer-events:auto;\n\tfont-size: 14px;\n\tcolor: #FFF;\n}\n\nselect {\n\twidth: 200px;\n}\n.menuTitle{\n    margin: auto;\n    position: absolute;\n    left: 330px;\n    right: 250px;\n    top: 12px;\n    text-align: -webkit-center;\n    color: #FFF;\n    text-overflow: ellipsis;\n    height: 30px;\n    white-space: nowrap;\n    overflow: hidden;\n}\n.menuItem {\n\tposition: inherit;\n    top: 10px;\n\tleft: 5px;\n\twidth: 350px;\n}\n.menuSelect {\n\tright: 5px;\n    position: inherit;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main